import { Oval } from "react-loader-spinner";

const LoadingSpinner = () => (
  <div className="grid w-full place-content-center py-8">
    <Oval
      height={48}
      width={48}
      color="#F49038"
      secondaryColor="#FDE9D8"
      strokeWidth={2}
      strokeWidthSecondary={2}
      visible={true}
      ariaLabel="oval-loading"
    />
  </div>
);

export default LoadingSpinner;
